import { Box, Heading, Paragraph } from 'grommet'
import styled, { css } from 'styled-components'

import HalfOrangeHexagon from '@public/images/orange-half.svg'
import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(Box)`
  position: relative;

  ${({ theme, marginTop }) => css`
    margin-top: ${marginTop};

    ${marginTop.toString() !== '0' &&
    css`
      ${theme.below.laptop`
        margin-top: ${theme.spaces[4]}px;
      `}
    `}
  `}
`
export const Content = styled(Box)`
  max-width: ${({ contentWidth }) => contentWidth};
  width: 100%;

  ${({ theme }) => css`
    ${theme.below.laptop`
      padding: 0 ${theme.newSpaces.xs2}px;
    `}

    ${theme.below.tabletS`
      padding: 0;
    `}

    ${theme.below.mobileXL`
      max-width: ${({ contentWidthMobile }) => contentWidthMobile};
    `}
  `}
`

export const ContentWrapper = styled(NormalizedWrapper)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  z-index: 1;

  ${({ theme, spacing }) => theme.below.laptop`
    justify-content:center;
    padding: 0 ${spacing || 0};

    &> div:not(:last-child) {
      margin-bottom: ${theme.spaces[4]}px;
    }
  `}

  ${({ theme }) => theme.below.mobileL`
      max-width: 360px;
  `}

  ${({ theme }) => theme.below.mobileM`
      max-width: 344px;
  `}
`

export const Title = styled(Heading)`
  ${({ theme, noTextTransform }) => css`
    ${theme.getTypography('desktop', 'title', 'title2')}

    color: ${theme.newColors.primary};
    margin-left: ${theme.newSpaces.xs}px;

    text-transform: ${noTextTransform ? 'none' : 'uppercase'};

    ${theme.below.mobileL`
      ${theme.getTypography('mobile', 'title', 'title3')}
    `}
  `}
`
export const Subtitle = styled(Paragraph)`
  color: ${({ theme }) => theme.colors.silver};
  font-size: ${({ theme }) => theme.fontSizes[14]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  line-height: 24px;
  & > a {
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.fontSizes[14]}px;
    font-weight: ${({ theme }) => theme.fontWeight[2]};
    line-height: 24px;
  }

  ${({ theme }) => theme.below.tabletM`
    ${theme.getTypography('mobile', 'body', 'body4')}

    & > a {
      font-size: ${({ theme, mobileFont }) =>
        mobileFont
          ? theme.fontSizes[mobileFont]
          : theme.typography.mobile.body.body4.fontSize}px;

      line-height: 18px;
    }
  `}
`
export const TitleWrapper = styled(Box)`
  align-items: center;
  flex-direction: row;

  img {
    object-fit: contain;
  }

  ${({ theme }) => css`
    margin: ${theme.newSpaces.xs}px 0;

    ${theme.below.mobileL`
      margin-top: 0;
      margin-bottom: ${theme.newSpaces.xs2}px;
    `}
  `}
`
export const OrangeHexagon = styled(HalfOrangeHexagon)`
  position: absolute;
  top: -200px;

  & > path {
    fill: transparent;
    transition: 0.2s all ease;

    &:hover {
      stroke-width: 8;
    }
  }

  ${({ theme }) => theme.below.desktopXS`
    display: none;
  `}

  ${({ theme }) => theme.below.laptopL`
    display: block;
  `}

  ${({ theme }) => theme.below.laptopML`
    display: none;
  `}
`
